import { createDecorator } from 'vue-class-component';

export default function makeDecorator(message) {
   return createDecorator(function _decorator(options, key) {
      options.methods = options.methods || {};
      options.methods[key] = function _emmiter(...args) {
         args.unshift(message);
         this.$emit.apply(this, args);
      };
   });
}
